import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
export default function ExternalIssuers(props) {
    return (_jsx(_Fragment, { children: "ExternalIssuers" }));
}
